import PageHeader from "@/components/site/PageHeader";
import SectionEyebrow from "@/components/site/SectionEyebrow";
import ConsultationBand from "@/components/site/ConsultationBand";
import { PRESS, RECOGNITION } from "@/lib/content";
import { ExternalLink } from "lucide-react";

export default function MediaPage() {
  return (
    <div data-testid="media-page">
      <PageHeader
        eyebrow="Media"
        title="Press, features, and recognition."
        lead="Selected coverage and acknowledgements that document the work and the people building it."
        testId="media-page-header"
      />

      <section className="pb-8 md:pb-12">
        <div className="wt-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <SectionEyebrow>Press &amp; features</SectionEyebrow>
              <ul className="mt-6 grid grid-cols-1 gap-4">
                {PRESS.map((p, i) => (
                  <li
                    key={p.url}
                    data-testid={`press-item-${i}`}
                    className="wt-card p-6"
                  >
                    <p className="wt-eyebrow">{p.publication}</p>
                    <h3 className="wt-h3 mt-2">{p.title}</h3>
                    {p.date && (
                      <p className="mt-1 text-xs wt-text-muted">{p.date}</p>
                    )}
                    {p.excerpt && <p className="mt-3 wt-body">{p.excerpt}</p>}
                    <a
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`press-link-${i}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold wt-link"
                    >
                      Read the article
                      <ExternalLink size={14} aria-hidden="true" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:col-span-4">
              <SectionEyebrow>Recognition</SectionEyebrow>
              <ul className="mt-6 space-y-3">
                {RECOGNITION.map((r, i) => (
                  <li
                    key={r}
                    data-testid={`media-recognition-${i}`}
                    className="flex gap-3 items-start"
                  >
                    <span
                      className="mt-1.5 inline-block h-1.5 w-1.5 rounded-full"
                      style={{ backgroundColor: "var(--wt-gold)" }}
                      aria-hidden="true"
                    />
                    <span className="wt-body text-sm">{r}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <ConsultationBand />
    </div>
  );
}
